import { DataFileInterface } from '@systemeio/file-manager'
import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export type ResourceFileType = Pick<
  DataFileInterface,
  'id' | 'name' | 'filename' | 'path' | 'thumbnail'
>

export const useResourceFiles = (digitalProductId?: DigitalProductId) => {
  const { user } = useUser()

  const { fetcher: listFetcher } = useFetch<RequestMethodsEnum.get, ResourceFileType[]>({
    method: RequestMethodsEnum.get,
  })

  const isFetchAllowed = !!user && !!digitalProductId

  return useControlledSwr<ResourceFileType[]>(
    `/api/dashboard/customer/all-data-files-by-digital-product/${digitalProductId}?order=next`,
    listFetcher,
    { revalidateOnMount: true },
    isFetchAllowed,
  )
}
